import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Receipt, Loader2 } from "lucide-react";
import { mxn } from "@/lib/api";
import { useStampPackages } from "@/components/distributor/StampDialog";

export function StampsSection() {
  const pkgs = useStampPackages();
  const navigate = useNavigate();
  return (
    <section id="timbres" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-28" data-testid="stamps-section">
      <div className="grid gap-10 lg:grid-cols-3">
        <div>
          <p className="overline text-primary">Facturación electrónica</p>
          <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight md:text-5xl">Timbres fiscales</h2>
          <p className="mt-4 text-muted-foreground">Compra paquetes de timbres para facturar CFDI desde ProfesionalPOS. Los cargamos a tu licencia con tu ID de activación.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-3">
          {!pkgs ? <Loader2 className="h-6 w-6 animate-spin text-primary" /> : pkgs.length === 0 ? (
            <p className="text-sm text-muted-foreground">Próximamente.</p>
          ) : pkgs.map((p, i) => (
            <div key={p.id} className="flex flex-col rounded-2xl border border-border bg-card p-6 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`stamp-card-${p.id}`}>
              <Receipt className="h-6 w-6 text-primary" />
              <p className="mt-4 font-display text-xl font-bold tracking-tight">{p.name}</p>
              <p className="mt-1 text-sm text-muted-foreground">{p.quantity.toLocaleString("es-MX")} timbres · {mxn(p.price / p.quantity)} c/u</p>
              <p className="mt-5 font-display text-3xl font-black tracking-tighter">{mxn(p.price)}</p>
              <Button className="mt-6 rounded-full" onClick={() => navigate(`/timbres/comprar?package=${p.id}`)} data-testid={`stamp-buy-${p.id}`}>Comprar</Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
